/* @refresh reload */
import { render } from 'solid-js/web';
import { App } from './App';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('Application root was not found.');

render(() => <App />, root);

document.querySelector<HTMLAnchorElement>('.skip-link')?.addEventListener('click', (event) => {
  const main = document.querySelector<HTMLElement>('#main-content');
  if (!main) return;
  event.preventDefault();
  window.history.replaceState(null, '', '#main-content');
  main.focus();
  main.scrollIntoView({ block: 'start' });
});
